<template>
  <el-card class="systemTableStyle" shadow="always">
    <el-table
      :load="load"
      :row-key="rowKey"
      :lazy="lazy"
      :data="tableData"
      :show-summary="showSummary"
      :summary-method="summaryMethod"
      :span-method="spanMethod"
      v-loading="loading"
      element-loading-text="正在加载数据..."
      :max-height="height ? height : tableHeight"
      border
      :header-cell-style="{
        background: '#F6F8FC',
        height: '40px',
        fontWeight: '600',
        color: '#333',
        border: 0,
      }"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
      @sort-change="tableSortFun"
      @current-change="clickChange"
    >
      <!--单选选择-->
      <el-table-column
        label="选择"
        width="60"
        align="center"
        v-if="radioShow"
        fixed="left"
      >
        <template slot-scope="scope">
          <el-radio v-model="tableRadio" :label="scope.row"><i></i></el-radio>
        </template>
      </el-table-column>
      <!--多选选择-->
      <el-table-column
        v-if="selectionShow"
        type="selection"
        align="center"
        width="40"
        :selectable="canSelect"
        fixed="left"
      >
      </el-table-column>
      <!--序号 自定义列序号-->
      <el-table-column
        v-if="indexShow"
        type="index"
        align="center"
        label="序号"
        width="80"
      >
        <template slot-scope="scope">
          <span>{{
            (pagination.currentNo - 1) * pagination.pageSize + scope.$index + 1
          }}</span>
        </template>
      </el-table-column>
      <template v-for="column in tableColumns">
        <!-- 要特殊处理的字段加上type='slot'，在各自的父组件中自主处理 -->
        <slot :name="column.key" v-if="column.type == 'slot'"></slot>
        <el-table-column
          v-else
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :min-width="
            column.rules
              ? column.rules.baseConfig.width
              : column.width
              ? column.width
              : ''
          "
          :sortable="column.rules || column.sort ? 'custom' : false"
          show-overflow-tooltip
          :align="
            column.rules && column.rules.baseConfig.align
              ? column.rules.baseConfig.align
              : column.align
              ? column.align
              : 'center'
          "
          :fixed="
            column.rules && column.rules.baseConfig.isFixed
              ? column.rules.baseConfig.isFixed
              : false
          "
        >
          <template slot-scope="scope">
            <!--自定义表格处理-->
            <template v-if="column.rules">
              <TextTable
                v-if="column.rules.type == 'text'"
                :data="scope.row[column.key]"
                :config="column"
              ></TextTable>
              <SelectTable
                v-if="column.rules.type == 'select'"
                :data="scope.row[column.key]"
                :config="column"
              ></SelectTable>
              <DateTable
                v-if="column.rules.type == 'date'"
                :data="scope.row[column.key]"
                :config="column"
              ></DateTable>
              <FileTable
                v-if="column.rules.type == 'file'"
                :data="scope.row[column.key]"
                :config="column"
              ></FileTable>
              <RichTable
                v-if="column.rules.type == 'rich'"
                :data="scope.row[column.key]"
                :config="column"
              ></RichTable>
            </template>
            <!--普通表格处理-->
            <template v-else>
              <span
                v-if="scope.row[column.key] || scope.row[column.key] === 0"
                >{{ scope.row[column.key] }}</span
              >
              <span v-else>-</span>
            </template>
          </template>
        </el-table-column>
      </template>
      <!--表格内部的操作插槽-->
      <slot></slot>
    </el-table>
    <el-pagination
      v-if="showPagination"
      class="pagination"
      background
      :pager-count="5"
      :current-page="page.currentNo"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-size="page.pageSize"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total,slot,sizes,prev,pager,next,jumper"
      :total="parseInt(page.total)"
    >
    </el-pagination>
  </el-card>
</template>

<script>
import DateTable from "../formTable/DateTable.vue";
import FileTable from "../formTable/FileTable.vue";
import SelectTable from "../formTable/SelectTable.vue";
import TextTable from "../formTable/TextTable.vue";
import RichTable from "../formTable/RichTable.vue";
export default {
  components: { TextTable, SelectTable, DateTable, FileTable, RichTable },
  name: "NewTable",
  props: {
    rowKey: {
      type: String,
      default: "",
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 0,
    },
    tableData: {
      type: Array,
      required: true,
      default: () => {
        return [];
      },
    },
    spanMethod: Function,
    summaryMethod: Function,
    tableColumns: {
      type: Array,
      required: true,
      default: () => {
        return [];
      },
    },
    showPagination: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Object,
      default: function () {
        return {
          currentNo: 1,
          total: 0,
          pageSize: 10,
        };
      },
    },
    radioShow: {
      // 单选 默认不显示
      type: Boolean,
      default: false,
    },
    selectionShow: {
      // 多选 默认不显示
      type: Boolean,
      default: false,
    },
    indexShow: {
      // 序号 默认不显示
      type: Boolean,
      default: false,
    },
    showSummary: {
      // 是否展示合计行
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableHeight() {
      return window.innerHeight - 280;
    },
    page: {
      get() {
        return this.pagination;
      },
      set(val) {
        this.$emit("update:pagination", val);
      },
    },
  },
  data() {
    return {
      tableRadio: "",
    };
  },
  methods: {
    // 懒加载子节点数据函数
    load(row, treeNode, resolve) {
      this.$emit("load", row, treeNode, resolve);
    },
    clickChange(item) {
      this.tableRadio = item;
      if (this.radioShow) {
        this.$emit("handleRadioChange", item);
      }
    },
    tableSortFun(item) {
      this.$emit("tableSortFun", item);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row && rowIndex % 2 == 1) {
        return "success-row";
      } else {
        return "";
      }
    },
    handleSummary(val) {
      this.$emit("summaryMethod", val);
    },
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    handleCurrentChange(val) {
      this.page.currentNo = val;
      this.$emit("pageChange");
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.$emit("pageChange");
    },
    canSelect(row) {
      return !row.diseditable;
    },
  },
};
</script>

<style lang="stylus">
.systemTableStyle
  .pagination
    margin: 20px auto 0px
    text-align: right
  .dataTableHead
    display: flex
    align-items: center
    margin-bottom: 10px
    width: 230px
    justify-content: space-between
  .columnStyle
    background: #fef0f0
  .el-table .success-row
    background: #F6F8FC
  .el-table .cell
    line-height: 30px
  /* 整体滚动条样式 */
  ::-webkit-scrollbar
    z-index: 100
    width: 10px !important
    height: 10px !important
  ::-webkit-scrollbar-thumb
    background-color: #ccc
    border-radius: 4px
.el-scrollbar__wrap::-webkit-scrollbar
  width: 10px !important
  height: 10px !important
</style>
